<template>
  <div class="main-container">
    <div class="form-row">
      <div class="form-row-input">
        <ejs-textbox
          ref="categoryName"
          float-label-type="Always"
          placeholder="Category Name"
          v-model="category.message"
        />
        <label v-if="categoryMessageError" class="e-error">This field is required</label>
      </div>
      <br />
      <div class="form-row-input">
        <ejs-textbox
          ref="categoryOrderId"
          float-label-type="Always"
          placeholder="Order"
          type="number"
          format="n"
          :min="min"
          v-model="category.orderId"
        />
        <label v-if="categoryOrderIdError" class="e-error">This field is required</label>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { NumericTextBoxPlugin } from "@syncfusion/ej2-vue-inputs";

Vue.use(NumericTextBoxPlugin);

export default {
  name: "FormsCategoryModalContent",
  data() {
    return {
      min: 1,
      category: { message: null, orderId: 0, messageId: null },
      categoryMessageError: false,
      categoryOrderIdError: false,
    };
  },
  methods: {
    validate() {
      if (this.category.message) {
        this.categoryMessageError = false;
      } else {
        this.categoryMessageError = true;
      }

      if (this.category.orderId) {
        this.categoryOrderIdError = false;
      } else {
        this.categoryOrderIdError = true;
      }

      if (this.categoryOrderIdError || this.categoryMessageError) {
        return null;
      }
      return this.category;
    },
    resetContent() {
      this.category = null;
      this.categoryOrderIdError = this.categoryMessageError = false;
    },
    setContent(key, category) {
      switch (key) {
        case "Add":
          this.category = { message: null, orderId: null, messageId: null };

          break;
        case "Edit":
          this.category = { ...category };
          break;
      }
    },
  },
};
</script>
<style>
@import "../../../../node_modules/@syncfusion/ej2-base/styles/material.css";
@import "../../../../node_modules/@syncfusion/ej2-vue-inputs/styles/material.css";
</style>
